import {getQuery} from "@/modules/common/utils";
import paginationUtil from "@/modules/common/utils/paginationUtil";

const list = async (params) => getQuery('payment_statuses', params)
const get = uid => getQuery(`payment_statuses/${uid}`);

const listAll = async (baseParams) => {
  const fetchPageFn = async (params) => {
    const response = await getQuery('payment_statuses', params);
    return response.data || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, baseParams);
};

const fetchOpenPaymentRequests = async (matterUid, baseParams = {}) => {
  const params = {
    new_api: true,
    'filter[matter_uid][eq]': matterUid,
    'filter[state][in]': 'DUE,OVERDUE',
    'filter[entity_type][in]': 'Meeting,EventAttendance,ProductOrder,ClientBookingPackage',
    'filter[amount_pending][lte]': 0,
    'filter[display]': true,
    sort: 'created_at:asc',
    per_page: 30,
    ...baseParams,
  };
  
  const fetchPageFn = async (pageParams) => {
    const response = await getQuery('/business/payments/v1/payment_requests', pageParams);
    return response.data?.payment_requests || [];
  };
  return paginationUtil.fetchAllPages(fetchPageFn, params);
};

export default {
  list,
  listAll,
  get,
  fetchOpenPaymentRequests,
}
